import React from "react";
import { StyledSection } from "./section.style";
import Field from "../formFields/field.component";

const Section = ({ data, children }) => {
  const { name, required, description, fields } = data;

  return (
    <StyledSection>
      <div>
        <h6>
          {name}
          {required ? "" : <span>(optional)</span>}
        </h6>
        <p>{description}</p>
      </div>
      <div>
        {typeof fields !== "undefined" ? (
          Array.isArray(fields) ? (
            fields.map((field, i) => <Field key={i} {...field} />)
          ) : (
            <Field {...fields} />
          )
        ) : (
          children
        )}
      </div>
    </StyledSection>
  );
};

export default Section;
